// StepSize — Phase 5 step 3.
// Captures employee count, revenue tier, and number of branches.
import React, { useState, useEffect } from 'react';
import { Button } from '../../../components/ui/button';
import { Users, ChevronRight } from 'lucide-react';

const EMP_RANGES   = ['1-10', '11-50', '51-200', '201-1000', '1000+'];
const REV_RANGES   = ['< 1M SAR', '1-10M SAR', '10-50M SAR', '50-250M SAR', '250M+ SAR'];

export default function StepSize({ initialData, onSubmit, busy }) {
  const [form, setForm] = useState({ employees: '11-50', annual_revenue: '1-10M SAR', branches: 1 });

  useEffect(() => {
    if (initialData) {
      const h = setTimeout(() => setForm((f) => ({ ...f, ...initialData })), 0);
      return () => clearTimeout(h);
    }
  }, [initialData]);

  return (
    <div data-testid="step-size" className="space-y-5">
      <div className="flex items-start gap-3">
        <div className="p-2 rounded-lg bg-indigo-50 text-indigo-700"><Users size={18} /></div>
        <div>
          <h2 className="text-lg font-bold text-slate-900">Company size</h2>
          <p className="text-sm text-slate-500 mt-0.5">Helps us pre-size payroll, branches and reporting frequency.</p>
        </div>
      </div>

      <PillGroup
        testid="size-employees"
        label="Employees"
        options={EMP_RANGES}
        value={form.employees}
        onChange={(v) => setForm((f) => ({ ...f, employees: v }))}
      />
      <PillGroup
        testid="size-revenue"
        label="Annual revenue"
        options={REV_RANGES}
        value={form.annual_revenue}
        onChange={(v) => setForm((f) => ({ ...f, annual_revenue: v }))}
      />

      <div>
        <label className="text-xs font-medium text-slate-500 mb-1 block">Branches / offices</label>
        <input
          data-testid="size-branches"
          type="number"
          min={1}
          value={form.branches}
          onChange={(e) => setForm((f) => ({ ...f, branches: Number(e.target.value) || 1 }))}
          className="px-3 py-2 rounded-md border border-slate-200 bg-white text-sm w-40"
        />
      </div>

      <div className="flex justify-end">
        <Button onClick={() => onSubmit(form)} disabled={busy} data-testid="size-save-btn" className="bg-indigo-600 hover:bg-indigo-700 text-white">
          Save & continue <ChevronRight size={14} className="ml-1.5" />
        </Button>
      </div>
    </div>
  );
}


function PillGroup({ testid, label, options, value, onChange }) {
  return (
    <div data-testid={testid}>
      <label className="text-xs font-medium text-slate-500 mb-2 block">{label}</label>
      <div className="flex flex-wrap gap-2">
        {options.map((o) => (
          <button
            type="button"
            key={o}
            onClick={() => onChange(o)}
            className={`px-3 py-1.5 rounded-full text-xs font-medium border transition ${
              value === o
                ? 'border-indigo-500 bg-indigo-50 text-indigo-800'
                : 'border-slate-200 bg-white text-slate-600 hover:border-slate-300'
            }`}
          >{o}</button>
        ))}
      </div>
    </div>
  );
}
